// extracted by mini-css-extract-plugin
export var container = "hero-module--container--WeT02";
export var canvas = "hero-module--canvas--HBr-c";
export var canvasMask = "hero-module--canvas-mask---Qoo5";
export var canvasButton = "hero-module--canvas-button--P-Fzj";
export var bounce = "hero-module--bounce--rYy09";
export var bounceHard = "hero-module--bounce-hard--ic8RU";
export var headingContainer = "hero-module--heading-container--VUY5a";
export var heading = "hero-module--heading--75A8h";